// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar__container__2isFD layout__fill__1rDTs","tab":"Sidebar__tab__1m9e1","chat":"Sidebar__chat__1UFqf","list":"Sidebar__list__3a7j0"};